import Vue from 'vue';
import Router from 'vue-router';

import Discover from './views/Discover/Discover.vue';
import Directory from './views/Directory/Directory.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'discover',
      component: Discover
    },
    {
      path: '/directory',
      name: 'directory',
      component: Directory
    }
  ]
})
